'use strict';

/**
 * <pippei-vendorstrip> (blocks/collection-vendor-info.liquid, in the section «Produktliste»): the narrow supplier strip on a collection page. A click on the strip opens the panel
 * in one of three ways, chosen per screen size (data-mode-d from 768 px, data-mode-m below):
 *   inline  - the panel opens under the strip and pushes the page down
 *   overlay - the panel lies over the page under the strip; outside click and Esc close it
 *   popup   - the panel is centred with a backdrop; the page does not scroll; Esc, the backdrop and the cross close it
 * The mode is set as data-mode and the state as data-open; the styles (.vs*) are in src/css/theme.css.
 */
(function () {
  if (customElements.get('pippei-vendorstrip')) return;

  class PippeiVendorStrip extends HTMLElement {
    connectedCallback() {
      if (this._ready) { if (this._onKey) this._listen(); return; }   /* moved to another slot: the listeners come back */
      this._ready = true;
      var self = this;
      this.btn = this.querySelector('[data-vs-toggle]');
      this.panel = this.querySelector('[data-vs-panel]');
      this.bd = this.querySelector('.vs-bd');
      if (!this.btn || !this.panel) return;
      this.mq = window.matchMedia('(min-width: 768px)');
      this._place();
      this._mode();
      var onMq = function () { var was = self.isOpen; if (was) self.close(false); self._place(); self._mode(); };
      if (this.mq.addEventListener) this.mq.addEventListener('change', onMq); else this.mq.addListener(onMq);

      this.btn.addEventListener('click', function () { self.isOpen ? self.close(true) : self.open(); });
      this.querySelectorAll('[data-vs-close]').forEach(function (el) { el.addEventListener('click', function () { self.close(true); }); });
      this._onKey = function (e) { if (e.key === 'Escape' && self.isOpen) { self.close(true); } };
      this._onDoc = function (e) { if (self.isOpen && self.dataset.mode === 'overlay' && !self.contains(e.target)) self.close(false); };
      this._listen();
    }

    _listen() {
      document.addEventListener('keydown', this._onKey);
      document.addEventListener('click', this._onDoc);
    }

    disconnectedCallback() {
      document.removeEventListener('keydown', this._onKey);
      document.removeEventListener('click', this._onDoc);
      document.documentElement.classList.remove('pk-lock');
    }

    /* The block is rendered in the toolbar slot (left of the sort dropdown); on screens where it should lie under the thin line it moves to the
       slot above the product grid. data-place tells the styles where it is. */
    _place() {
      var place = this.mq.matches ? this.getAttribute('data-place-d') : this.getAttribute('data-place-m');
      var slot = document.querySelector('[data-vs-slot="' + (place === 'below' ? 'below' : 'toolbar') + '"]');
      var node = this.parentNode && this.parentNode.classList && this.parentNode.classList.contains('shopify-block') ? this.parentNode : this;
      if (slot && !slot.contains(node)) slot.appendChild(node);
      this.dataset.place = place === 'below' ? 'below' : 'toolbar';
      this.setAttribute('data-ready', '');
    }

    _mode() {
      this.dataset.mode = this.mq.matches ? this.getAttribute('data-mode-d') : this.getAttribute('data-mode-m');
      if (this.dataset.place === 'toolbar' && this.dataset.mode === 'inline') this.dataset.mode = 'overlay';
      var popup = this.dataset.mode === 'popup';
      this.panel.setAttribute('role', popup ? 'dialog' : 'region');
      if (popup) this.panel.setAttribute('aria-modal', 'true'); else this.panel.removeAttribute('aria-modal');
    }

    open() {
      this.isOpen = true;
      this.setAttribute('data-open', '');
      this.btn.setAttribute('aria-expanded', 'true');
      this.panel.hidden = false;
      if (this.bd) this.bd.hidden = this.dataset.mode !== 'popup';
      if (this.dataset.mode === 'popup') {
        document.documentElement.classList.add('pk-lock');
        this.panel.focus({ preventScroll: true });
      }
    }

    close(refocus) {
      this.isOpen = false;
      this.removeAttribute('data-open');
      this.btn.setAttribute('aria-expanded', 'false');
      this.panel.hidden = true;
      if (this.bd) this.bd.hidden = true;
      document.documentElement.classList.remove('pk-lock');
      if (refocus) this.btn.focus({ preventScroll: true });
    }
  }

  customElements.define('pippei-vendorstrip', PippeiVendorStrip);
})();
